import React from 'react';
import { Flame, Star, Truck } from 'lucide-react';

export const AboutSectionDark = () => {
  const values = [
    {
      id: 'freshness',
      icon: Flame,
      title: "Frescura Garantizada",
      description: "Ingredientes frescos todos los días, directo de proveedores locales de confianza"
    },
    {
      id: 'quality',
      icon: Star,
      title: "Calidad Premium",
      description: "Solo usamos los mejores cortes de carne y pollo de la más alta calidad"
    },
    {
      id: 'delivery',
      icon: Truck,
      title: "Entrega Rápida",
      description: "Realizamos envíos en toda la ciudad, ¿qué esperas para tener tu comida caliente y crujiente en la puerta de tu casa?"
    }
  ];

  return (
    <section id="sobre-nosotros" className="py-20 bg-gradient-to-b from-black to-red-950/20 relative overflow-hidden">
      {/* Blurred fries background */}
      <div 
        className="fries-bg-blur" 
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1518013431117-eb1465fa5752)'
        }}
      ></div>
      
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/90"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left - Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img
                src="https://customer-assets.emergentagent.com/job_menu-delicioso-2/artifacts/m4g74cu7_WhatsApp%20Image%202025-12-16%20at%201.09.44%20PM.jpeg"
                alt="Hamburguesa Mr. Crunch 28"
                className="rounded-2xl shadow-lg shadow-red-900/50 w-full h-48 object-cover border-2 border-orange-500/30"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_menu-delicioso-2/artifacts/k4f94p8s_WhatsApp%20Image%202025-12-16%20at%201.09.45%20PM.jpeg"
                alt="Pollo frito Mr. Crunch 28"
                className="rounded-2xl shadow-lg shadow-red-900/50 w-full h-64 object-cover border-2 border-orange-500/30"
              />
            </div>
            <div className="space-y-4 pt-8">
              <img
                src="https://customer-assets.emergentagent.com/job_menu-delicioso-2/artifacts/0xco5sa6_WhatsApp%20Image%202025-12-16%20at%201.09.47%20PM.jpeg"
                alt="Promoción Mr. Crunch 28"
                className="rounded-2xl shadow-lg shadow-red-900/50 w-full h-full object-cover border-2 border-orange-500/30"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold">
              Nuestra <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">Historia</span>
            </h2>
            
            <p className="text-2xl font-semibold text-orange-500 italic">
              "¡Crujiente por fuera, irresistible por dentro!"
            </p>
            
            <p className="text-lg text-gray-300 leading-relaxed">
              Mr Crunch 28 nació en 2023 con una visión clara: elevar la experiencia del pollo frito y la cocina casual a un nuevo nivel, combinando sabor auténtico, procesos cuidados y una atención impecable.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              Desde nuestros inicios, cada receta ha sido desarrollada con precisión y respeto por los ingredientes. Seleccionamos cuidadosamente nuestras materias primas, marinamos con fórmulas propias y preparamos cada platillo al momento, garantizando frescura, textura y un sabor inconfundible en cada servicio.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              En Mr Crunch creemos que la calidad se percibe en los detalles: el crujiente perfecto, el punto exacto de cocción, el balance de sabores y la experiencia que vive cada cliente desde el primer contacto hasta el último bocado.
            </p>

            <p className="text-lg text-gray-300 leading-relaxed">
              Nuestro compromiso no es solo alimentar, sino crear momentos memorables alrededor de la buena comida. Hoy, Mr Crunch continúa evolucionando con la misma filosofía que nos vio nacer: <span className="text-orange-500 font-semibold">excelencia, constancia e innovación</span>.
            </p>

            {/* Values Grid */}
            <div className="grid gap-6 pt-6">
              {values.map((value) => {
                const Icon = value.icon;
                return (
                  <div key={value.id} className="flex items-start space-x-4 group">
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg shadow-red-900/50">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-white mb-1">{value.title}</h3>
                      <p className="text-gray-400">{value.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};